import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError } from 'rxjs/operators';
import { NEVER, Observable } from 'rxjs';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { Group, VendorModel } from '../../models/group.model';
import * as groupsActions from '../../groups.actions';
import { GROUP_CURRENCY } from '../../constants/currency.constant';
import { cloneDeep } from 'lodash';


@Component({
  selector: 'app-business-groups-edit-dialog',
  templateUrl: './business-groups-edit-dialog.component.html',
  styleUrls: ['./business-groups-edit-dialog.component.scss']
})
export class BusinessGroupsEditDialogComponent implements OnInit {
  editGroupForm!: FormGroup;
  name = new FormControl('', Validators.required);
  code = new FormControl('');
  active = new FormControl('', Validators.required);
  questionnaireId = new FormControl('');
  cmEnabled = new FormControl('');
  rpmEnabled = new FormControl('');
  ftpUser = new FormControl('');
  ftpPass = new FormControl('');
  ftpProcessFlag = new FormControl('');
  ftpProcessType = new FormControl('', Validators.required);
  currency = new FormControl('')
  externalFtpHost = new FormControl('');
  externalFtpUser = new FormControl('');
  externalFtpPassword = new FormControl('');
  externalFtpPath = new FormControl('');
  type = new FormControl({value: '', disabled: true}, Validators.required);
  evalEnabled = new FormControl('');
  aggregator = new FormControl('');
  process6373flag = new FormControl('');
  interactionsHubFlag = new FormControl(false);
  interactionsHubClient = new FormControl(false);

  connectionType =  new FormControl('');

  currencyList = Object.values(GROUP_CURRENCY);
  filteredCurrency: string[] = [...this.currencyList];
  selectedType = '';
  vendorsList = ['A2 Dealogic', 'Bloomberg', 'Commcise', 'CorpAxe', 'S&P Evaluation', 'Red Deer', 'Transparens'];
  noVendorSelected = false;
  hideSFTPpassword = true;

  constructor(public dialogRef: MatDialogRef<BusinessGroupsEditDialogComponent>,
              private formBuilder: FormBuilder,
              private store: Store,
              @Inject(MAT_DIALOG_DATA) public data: Group) {
    this.interactionsHubFlag.setValue(this.data.interactionsHub);
    this.interactionsHubClient.setValue(this.data.interactionsHubClient);
  }

  ngOnInit() {
    this.editGroupForm = this.formBuilder.group({
      name: this.name,
      code: this.code,
      questionnaireId: this.questionnaireId,
      active: this.active,
      cmEnabled: this.cmEnabled,
      rpmEnabled: this.rpmEnabled,
      ftpPass: this.ftpPass,
      ftpUser: this.ftpUser,
      ftpProcessFlag: this.ftpProcessFlag,
      ftpProcessType: this.ftpProcessType,
      currency: this.currency,
      externalFtpHost: this.externalFtpHost,
      externalFtpUser: this.externalFtpUser,
      externalFtpPassword: this.externalFtpPassword,
      externalFtpPath: this.externalFtpPath,
      type: this.type,
      evalEnabled: this.evalEnabled,
      aggregator: this.aggregator,
      process6373flag: this.process6373flag,
      connectionType: this.connectionType,
      interactionsHubFlag: this.interactionsHubFlag,
      interactionsHubVendors: this.formBuilder.array([]),
      interactionsHubClient: this.interactionsHubClient
    });
    this.vendorsList.forEach(vendor => {
      let selectedVendor: VendorModel | undefined = this.data.vendorModels.find(ele => ele.name === vendor);
      this.interactionsHubVendors.push(this.formBuilder.group({
        name: vendor,
        id: selectedVendor?.id || null,
        vendorId: [{value: selectedVendor?.vendorId || '', disabled: !selectedVendor?.active }, [Validators.pattern('^[a-zA-Z0-9]+$')]],
        selected: selectedVendor?.active || false
      }));
    });
    this.editGroupForm.controls.code.disable();
  }

  get interactionsHubVendors() {
    return this.editGroupForm.controls['interactionsHubVendors'] as FormArray;
  }

  submit(): void {
    this.data.aggregator = this.data.orgAggregator;
    this.data.interactionsHub = this.interactionsHubFlag.value ?? false;
    this.data.interactionsHubClient = this.interactionsHubClient.value ?? false;
    this.interactionsHubVendors.value.forEach((vendor: any) => {
      const vendorModel = this.data.vendorModels.find(ele => ele.name === vendor.name);
      if (vendorModel) {
        vendorModel.vendorId = vendor.vendorId ?? vendorModel.vendorId;
        vendorModel.active = this.interactionsHubFlag.value ? vendor.selected : false;
      } else {
        if (vendor.selected) {
          this.data.vendorModels.push({name: vendor.name, vendorId: vendor.vendorId, active: vendor.selected, id: vendor.id});
        }
      }
    });
    if (this.data.interactionsHub && this.data.vendorModels.length === 0) {
      this.noVendorSelected = true;
      return;
    } else {
      this.noVendorSelected = false;
    }
    this.store.dispatch(new groupsActions.UpdateGroup(this.data))
      .pipe(catchError(error => this.onServerErrorHandling(error, this.editGroupForm)))
      .subscribe((data) => {
        this.dialogRef.close(this.data);
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSearchCurrency(event: string): string[] {
    const search = event && event.trim().toLowerCase();
    if (!search) {
      return this.filteredCurrency = [...this.currencyList];
    }
    this.filteredCurrency = this.currencyList.filter(option => option.toLowerCase().indexOf(search) === 0);
    return this.filteredCurrency;
  }

  private onServerErrorHandling(error: any, form: FormGroup): Observable<any> {
    let validationErrors = error.error.validationErrors;
    if (validationErrors) {
      validationErrors.forEach((beError: any) => {
        form.controls[beError.field].setErrors({backend: beError.defaultMessage});
      });
    }
    return NEVER;
  }

  onChangeFtpProcessType($event: string): void {
    if ($event !== 'EXTERNAL') {
      this.externalFtpHost.setValue('');
      this.externalFtpPath.setValue('');
      this.externalFtpUser.setValue('');
      this.externalFtpPassword.setValue('');
      this.connectionType.setValue(null);
    }
  }

  onChangeType(event: string): void {
    if (event) {
      this.selectedType = event;
      switch (event) {
        case 'CSA_BROKER':
          // CSA Broker
          this.editGroupForm.controls['rpmEnabled'].disable();
          this.editGroupForm.controls['evalEnabled'].disable();
          break;
        case 'ASSET_MANAGER':
          // Asset Manager
          this.editGroupForm.controls['rpmEnabled'].disable();
          this.editGroupForm.controls['evalEnabled'].enable();
          break;
        case 'SERVICE_PROVIDER':
          // Service Provider
          this.editGroupForm.controls['evalEnabled'].disable();
          this.editGroupForm.controls['rpmEnabled'].enable();
          break;
      }
    }
  }

  sppChanged({checked}: { checked: boolean }): void {
    if(!checked) {
      this.data.orgAggregator = false;
      this.data.orgPublishOnUpload = false;
    }
  }

  onVendorSelect({checked}: { checked: boolean }, index: any) {
    let selectedVendorList = [];
    const interactionsHubVendors = cloneDeep(this.interactionsHubVendors.value);
    interactionsHubVendors.forEach((ele: any) => {
      if (ele.selected) {
        selectedVendorList.push({name: ele.name, vendorId: ele.vendorId, active: ele.selected, id: ele.id});
      }
    });
    if (selectedVendorList.length === 0) {
      this.noVendorSelected = true;
    } else {
      this.noVendorSelected = false;
    }
    const vendor = this.interactionsHubVendors.at(index) as FormGroup;
    if (checked) {
      const vendorIdControl = vendor.get('vendorId');
      if (vendorIdControl) {
        vendorIdControl.enable();
      }
    } else {
      const vendorIdControl = vendor.get('vendorId');
      if (vendorIdControl) {
        vendorIdControl.disable();
      }
    }
  }
}
